export const CONFIRM_ANSWERS = "CONFIRM_ANSWERS";
export const GET_QUESTION = "GET_QUESTION";
export const SET_QUESTION = "SET_QUESTION";
export const SUBMIT_FORM = "SUBMIT_FORM";
export const SUBMIT_RESPONSE = "SUBMIT_RESPONSE";
export const EMAIL_FORM =  "EMAIL_FORM";
export const EDIT_RESPONSE = "EDIT_RESPONSE";
export const GET_QUESTIONS_AZ_ENGLISH = "GET_QUESTIONS_AZ_ENGLISH";
export const GET_QUESTIONS_AZ_SPANISH = "GET_QUESTIONS_AZ_SPANISH";
export const SET_RESPONSE = "SET_RESPONSE";
export const INCREMENT_INDEX_ENGLISH = "INCREMENT_INDEX_ENGLISH";
export const DECREMENT_INDEX_ENGLISH = "DECREMENT_INDEX_ENGLISH";
export const INCREMENT_INDEX_SPANISH = "INCREMENT_INDEX_SPANISH";
export const DECREMENT_INDEX_SPANISH = "DECREMENT_INDEX_SPANISH";
export const NEXT_QUESTION = "NEXT_QUESTION";
export const PREVIOUS_QUESTION = "PREVIOUS_QUESTION";
export const SET_QUESTION_AZ_SPANISH = "SET_QUESTION_AZ_SPANISH";
export const SET_RESPONSES_SPANISH = "SET_RESPONSES_SPANISH";
export const GET_RESPONSE_SPANISH = "GET_RESPONSE_SPANISH";
export const GET_RESPONSES_SPANISH = "GET_RESPONSES_SPANISH";



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js